<template>
  <div>
    <h1>LINE接続作業ウィザード</h1>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="商談ID" v-model="sfOpportunityId" />
        <button class="btn btn-other-action" @click="loadSfOpportunity" :disabled="operationType === ''">SFから読み込み</button>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        Notionコピー項目
        <input class="form-control" type="text" placeholder="Notionコピー項目（タブ区切り）" v-model="notionInput" />
        <button class="btn btn-other-action" @click="loadShopId">Notion情報から読み込み</button>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="ショップID" v-model="shopId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="医院名" v-model="name" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder=" サクセス担当者" v-model="follow" />
      </div>
    </div>

    <div v-if="currentStep === 0">
      <h2>1. LINE OAM権限の取得</h2>
      <ol>
        <li>
          サクセス担当より、LINE OAM権限を取得するためのURLの提供を受ける<br>
          ※1人にしか紐づけられないURLなので、SCOグループ堂谷のアカウントでアクセスする
        </li>
        <li>
          LINEアカウントでログイン＞SCOグループ 堂谷＞アカウントリストに追加される<br>
          このとき、権限が「管理者」であることを確認し、運用担当者等の管理者以外の場合はサクセス担当に連絡<br/>
          以下コメントを添えて、Notionより差し戻し
        </li>
      </ol>
      <textarea readonly :value="oamRetryTxt" class="form-control" rows="3"></textarea>
      <input type="button" value="コピー" class="btn btn-other-action" @click="copy(oamRetryTxt)" />
      <p>追加完了後、アカウントリスト（<a href="https://manager.line.biz/" target="_blank">https://manager.line.biz/</a>）に表示されるアカウント数を確認<br>100件が上限値なので、80件を超えたらそろそろ新しいアカウント作成の準備をする</p>
    </div>

    <div v-if="currentStep === 1">
      <h2>2. 公式アカウント設定確認</h2>
      医院の公式アカウントにログインする。
      <ol>
        <li>
          右上の「設定」を押下
        </li>
        <li>
          左メニューの設定>登録情報より、「管理者情報」にメールアドレスが登録されていることを確認する
          <br>
            登録されていなければ、以下コメントを添えて差し戻し
          <textarea readonly :value="oamMailNotSetTxt" class="form-control" rows="2"></textarea>
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy(oamMailNotSetTxt)" />
        </li>
        <li>
          左メニューの設定>Messaging APIより、「MessagingAPIを利用する」を押下
          <br>ステータスが「未利用」であれば次工程へ
          <details>
            <summary><strong>既にMessaging APIが利用中の場合（クリックで展開）</strong></summary>
            <ol>
              <li>Notionにてサクセスより申し送り事項がないか確認する<br>（依頼時に別途招待されていることもあるため）</li>
              <li>招待送信済みとの連携があれば、NGT堂谷さんに <code>shun.dotani+line01@scogr.co.jp</code> に送られてきているはずの招待メールを確認してもらう</li>
              <li>確認が済んだら、以下URLの末尾にMessaging APIのチャネルIDをコピペしてアクセスする
                <br><code>https://developers.line.biz/console/channel/{Messaging APIのチャネルID}</code>
              </li>
            </ol>
            <div class="alert alert-success">
              <strong>連携作業可能（次工程へ進む）条件：</strong>
              <ul>
                <li>チャネル詳細画面に遷移し、「Admin」のバッチが表示されている</li>
                <li>パンくずより、プロバイダー画面へ遷移し、プロバイダーのチャネル設定・権限設定・プロバイダー設定が閲覧できる状態である</li>
                <li>LINEログインが作成済みであれば、プロバイダー画面にてLINEログインが「Admin」バッチ付きで表示されている</li>
              </ul>
            </div>
            <div class="alert alert-danger">
              <strong>以下の場合は、サクセスに連携して正しく招待し直してもらう：</strong>
              <ul>
                <li>Messaging APIのチャネル詳細画面にアクセスできず404エラーが表示される<br>→ 招待すべきプロバイダー及びMessaging APIが違う（別で作成してしまったなど）。公式アカウントに紐づくプロバイダー及びMessaging APIに招待し直してもらう必要がある</li>
                <li>Adminバッチがついていない、プロバイダー画面で閲覧できないものがある<br>→ 権限が違うので、Adminとして招待してもらう必要がある</li>
              </ul>
            </div>
            <p><strong>招待されていない場合：</strong><br>
            作成済みのプロバイダー及びMessaging APIの権限を付与してもらう必要があるので、以下コメントを添えて差し戻し</p>
            <textarea readonly :value="messagingApiAlreadyInUseTxt" class="form-control" rows="8"></textarea>
            <input type="button" value="コピー" class="btn btn-other-action" @click="copy(messagingApiAlreadyInUseTxt)" />
            <br>招待完了の連絡が来たら、NGT堂谷さんを捕まえて shun.dotani+line01@scogr.co.jp に送られてきているはずの招待メールを確認してもらう。
          </details>
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 2">
      <h2>3. 契約状況確認</h2>
      <div v-if="aiCallPlanStatus === 'active'" class="alert alert-warning">
        <strong>paylight Call 稼働中の契約あり</strong>（契約ID: <a :href="`/manage/store_ai_call_contracts/${aiCallContractId}/workflows/new`" target="_blank">{{ aiCallContractId }}</a>、プラン期間: {{ aiCallPlanStartDate }} 〜 {{ aiCallPlanEndDate || '未定' }}）
        <p>Call契約でLINE連携されているかどうか以下から確認。</p>
        <ol>
          <li><a :href="`/manage/store_ai_call_contracts/${aiCallContractId}/workflows/new`" target="_blank">Call契約詳細</a> &gt; オプション</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1GNuceXzjbQfGpNgfR6FXTaSdfn1zJnO-h9zESQ189kA/edit?resourcekey=&gid=2010041961#gid=2010041961" target="_blank">AIでんわ連携SS - システム部連携用_PLCX</a> &gt; シートをShopIDで検索</li>
        </ol>
        <p>LINE連携済みであれば、その旨サクセスに共有。<br>以下コメントを添えて差し戻し。</p>
        <textarea readonly :value="callActiveLineLinkedTxt" class="form-control" rows="5"></textarea>
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(callActiveLineLinkedTxt)" />
      </div>
      <div v-else-if="aiCallPlanStatus === 'ended'" class="alert alert-info">
        <strong>paylight Call 終了済みの契約あり</strong>（契約ID: <a :href="`/manage/store_ai_call_contracts/${aiCallContractId}/workflows/new`" target="_blank">{{ aiCallContractId }}</a>、プラン期間: {{ aiCallPlanStartDate }} 〜 {{ aiCallPlanEndDate }}）
        <p>Call契約でLINE連携されているかどうか以下から確認。</p>
        <ol>
          <li><a :href="`/manage/store_ai_call_contracts/${aiCallContractId}/workflows/new`" target="_blank">Call契約詳細</a> &gt; オプション</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1GNuceXzjbQfGpNgfR6FXTaSdfn1zJnO-h9zESQ189kA/edit?resourcekey=&gid=2010041961#gid=2010041961" target="_blank">AIでんわ連携SS - システム部連携用_PLCX</a> &gt; シートをShopIDで検索</li>
        </ol>
        <p>スプシのステータスが「連携解除済み」となっていれば、改めて連携作業をしてOK</p>
      </div>
      <div v-else class="alert alert-success">
        <strong>paylight Call 契約なし</strong>
      </div>
      <div v-if="plxContractStatus === 'active'" class="alert alert-success">
        <strong>paylight X 稼働中の契約あり</strong>（契約ID: <a :href="`/manage/store_platform_contracts/${plxContractId}/workflows/new`" target="_blank">{{ plxContractId }}</a>、契約期間: {{ plxContractStartDate }} 〜 ）
      </div>
      <div v-else-if="plxContractStatus === 'ended'" class="alert alert-info">
        <strong>paylight X 終了済みの契約あり</strong>（契約ID: <a :href="`/manage/store_platform_contracts/${plxContractId}/workflows/new`" target="_blank">{{ plxContractId }}</a>、契約期間: {{ plxContractStartDate }} 〜 {{ plxContractEndDate }}）
        <p>解約になっているので、新しく契約をし直すのか等を確認する必要がある。<br>以下コメントを添えて差し戻し</p>
        <textarea readonly :value="plxEndedTxt" class="form-control" rows="4"></textarea>
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(plxEndedTxt)" />
      </div>
      <div v-else class="alert" style="background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;">
        <strong>paylight X 契約なし</strong>
        <div v-if="aiCallPlanStatus === 'active'">
          <p><strong>Xへの乗せ替え対応が必要。</strong><br>以下コメントを添えて差し戻し</p>
          <textarea readonly :value="callActiveNoPlxTxt" class="form-control" rows="11"></textarea>
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy(callActiveNoPlxTxt)" />
        </div>
        <div v-else>
          <p><strong>Xの契約締結が必要。</strong><br>以下コメントを添えて差し戻し</p>
          <textarea readonly :value="noPlxContractTxt" class="form-control" rows="3"></textarea>
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy(noPlxContractTxt)" />
        </div>
      </div>
    </div>

    <div v-if="currentStep === 3">
      <h2>4. プロバイダーの作成</h2>
      医院の公式アカウントにログインして作業を行う。
      <label class="control-label">LINE OAMより、</label>
      <div class="row">
        <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <input class="form-control" type="text" placeholder="LINE公式アカウント名" v-model="fixedName" />
          <small style="color: #e67e22;">※OAMのアカウント名がイマイチだったり医院名とかけ離れていたりする場合は若干の加工を行う</small>
        </div>
        <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <input class="form-control" type="text" placeholder="LINE公式ID" v-model="lineOfficialId" />
        </div>
      </div>
      <label class="control-label">登録情報より、</label>
      <div class="row">
        <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <input class="form-control" type="text" placeholder="メールアドレス" v-model="mail" />
        </div>
      </div>

      <ol>
        <li>
          右上の「設定」を押下
        </li>
        <li>
          左メニューの設定>Messaging APIより、「MessagingAPIを利用する」を押下<br>
        </li>
        <li>
          プロバイダー名：{{ shopId }}_{{ fixedName }}
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy(shopId + '_' + fixedName)" />
        </li>
        <li>
          同意すると「プライバシーポリシー＆利用規約」についてポップアップ⇒スルーしてOK
        </li>
        <li>
          ダイアログ「変更・解除できませんのでご注意ください」⇒アカウント名とプロバイダー名が同一であることを確認してOK<br>
          ※再作成はできない
        </li>
      </ol>
    </div>
    <label class="control-label" v-if="currentStep > 3">LINE OAMより、登録情報</label>
    <div class="row" v-if="currentStep > 3">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="LINE公式アカウント名" v-model="fixedName" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="LINE公式ID" v-model="lineOfficialId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="メールアドレス" v-model="mail" />
      </div>
    </div>


    <div v-if="currentStep === 4">
      <h2>5. Messaging APIの登録</h2>
      <ol>
        <li>
          「その他の設定はLINE Developersコンソールから行えます」を押下
        </li>
        <li>
          画面左上コンソールを押下
        </li>
        <li>
          プロバイダーの検索ボックスで該当医院を検索・選択＞該当医院のプロバイダー画面を開く（URLがhttps://developers.line.biz/console/provider/{プロバイダーID}となっている画面）<br>
          <input type="button" value="プロバイダー名（医院名）をコピー" class="btn btn-other-action" @click="copy(fixedName)" />
        </li>
        <li>
          Messaging API>チャネル基本設定>メールアドレス：{{ mail }}
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy(mail)" />
        </li>
      </ol>
    </div>

    <label class="control-label" v-if="currentStep >= 4">プロバイダー</label>
    <div class="row" v-if="currentStep >= 4">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="プロバイダーID" v-model="providerId" />
      </div>
    </div>
    <label class="control-label" v-if="currentStep >= 4">Messaging API</label>
    <div class="row" v-if="currentStep >= 4">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="Messaging API設定>ボットのベーシックID" v-model="messagingBasicId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="チャネル基本設定>チャネルID" v-model="messagingChannelId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="チャネル基本設定>チャネルシークレット" v-model="messagingChannelSecret" />
      </div>
    </div>

    <div v-if="currentStep === 5">
      <h2>6. LINEログインの登録</h2>
      <ol>
        <li>
          パンくずより該当医院のページに戻り、新規チャネル作成>LINEログインを押下
        </li>
        <li>
          <table class="table table-striped">
            <tbody>
            <tr>
              <td>所在地</td>
              <td>日本</td>
            </tr>
            <tr>
              <td>チャネル名</td>
              <td>{{ fixedName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(fixedName)" /></td>
            </tr>
            <tr>
              <td>チャネル説明</td>
              <td>{{ fixedName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(fixedName)" /></td>
            </tr>
            <tr>
              <td>アプリタイプ</td>
              <td>ウェブアプリ</td>
            </tr>
            <tr>
              <td>メールアドレス</td>
              <td>{{ mail }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(mail)" /></td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>
          同意する<br>作成
        </li>
        <li>
          作成したLINEログインを開き、<strong>開発中●</strong>を<strong>公開する●</strong>に変更する
        </li>
        <li>
          友達追加オプション>リンクされたLINE公式アカウント>{{ fixedName }}のものを選択・更新
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 6">
      <h2>7. LIFFアプリの登録</h2>
      <ol>
        <li>
          LIFFタブ＞追加
          <table class="table table-striped">
            <tbody>
            <tr>
              <td>LIFFアプリ名</td>
              <td>paylight X<input type="button" value="コピー" class="btn btn-other-action" @click="copy('paylight X')" /></td>
              <td></td>
            </tr>
            <tr>
              <td>サイズ</td>
              <td>Full</td>
              <td></td>
            </tr>
            <tr>
              <td>エンドポイントURL</td>
              <td><input type="button" value="ダミー値をコピー" class="btn btn-other-action" @click="copy(dummyEndPointUrl)" /></td>
              <td></td>
            </tr>
            <tr>
              <td>Scope</td>
              <td>openid, profile, chat_message.write</td>
              <td>すべてチェック<br>chat_message.write選択でダイアログ表示→有効</td>
            </tr>
            <tr>
              <td>友達追加オプション</td>
              <td>On(aggressive)</td>
              <td></td>
            </tr>
            <tr>
              <td>Scan QR</td>
              <td>OFF</td>
              <td></td>
            </tr>
            <tr>
              <td>モジュールモード</td>
              <td>OFF</td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </li>
      </ol>
    </div>

    <label class="control-label" v-if="currentStep >= 6">LINEログイン</label>
    <div class="row" v-if="currentStep >= 6">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="LIFF>LIFF ID" v-model="liffId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="チャネル基本設定>チャネルID" v-model="liffChannelId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="チャネル基本設定>チャネルシークレット" v-model="liffChannelSecret" />
      </div>
    </div>

    <div v-if="currentStep === 7">
      <h2>8. スプレッドシート更新</h2>
      <a href="https://docs.google.com/spreadsheets/d/1GNuceXzjbQfGpNgfR6FXTaSdfn1zJnO-h9zESQ189kA/edit?resourcekey=&gid=2010041961#gid=2010041961&range=A1" target="_blank">PayLightCall連携SSのシステム部連携用_PLCX</a>に以下を記載する<br>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" readonly :value="opsInsightStartTxt" />
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(opsInsightStartTxt)" />
      </div>
    </div>

    <div v-if="currentStep === 8">
      <h2>9. glenfiddichへのデータ登録</h2>
      <textarea readonly class="form-control" rows="5">@ops No.**のLINE接続作業をお願いします。</textarea>
    </div>

    <div v-if="currentStep === 9">
      <h2>10. 正式版URLの登録</h2>
      <ol>
        <li>
          スプレッドシートからA-P列を以下にコピー
          <div class="row">
            <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <input class="form-control" type="text" v-model="ssRecord" />
            </div>
          </div>
        </li>
        <li>
          Messaging API>Messaging API設定>Webhook設定>Webhook URL<br>
          {{ webhookUrl }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(webhookUrl)" /><br>
          検証ボタンを押し、「成功」となることを確認する
        </li>
        <li>
          LINEログイン>LIFF>paylight X>エンドポイントURL<br>
          {{ endPointUrl }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(endPointUrl)" />
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 10">
      <h2>11. webhook設定の更新</h2>
      Messaging API>Messaging API設定>Webhook設定<br>
      表示されるダイアログは「理解しました」に☑する
      <table class="table table-striped">
        <tbody>
        <tr>
          <td>webhook利用</td>
          <td>On</td>
        </tr>
        <tr>
          <td>webhook再送</td>
          <td>On</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="currentStep === 11">
      <h2>12. スタッフ登録</h2>
      <ol>
        <li>
          paylightになりすましログインする<br>
          <a :href="storeListUrl" target="_blank">加盟店一覧>{{ this.shopId }}を検索</a>>詳細・編集>PLスタッフ一覧>オーナー印がついているアカウント
        </li>
        <li>
          paylight>設定>スタッフ管理>スタッフの新規作成
          <table class="table table-striped">
            <tbody>
            <tr>
              <td>氏名（姓）</td>
              <td>paylight<input type="button" value="コピー" class="btn btn-other-action" @click="copy('paylight')" /></td>
            </tr>
            <tr>
              <td>氏名（名）</td>
              <td>X<input type="button" value="コピー" class="btn btn-other-action" @click="copy('X')" /></td>
            </tr>
            <tr>
              <td>メールアドレス</td>
              <td>pay-light-cx@scogr.co.jp<input type="button" value="コピー" class="btn btn-other-action" @click="copy('pay-light-cx@scogr.co.jp')" /></td>
            </tr>
            <tr>
              <td>ユーザータイプ</td>
              <td>事務長（DM）</td>
            </tr>
            <tr>
              <td>ユーザーロール</td>
              <td>管理</td>
            </tr>
            <tr>
              <td>予約対象</td>
              <td><strong>非対象</strong></td>
            </tr>
            </tbody>
          </table>
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 12">
      <h2>13. 加盟店設定より、LINE公式の登録</h2>
      <a :href="plxSettingListUrl" target="_blank">加盟店のX設定</a>より、諸々の値の登録を行う。
      <table class="table table-striped">
        <tbody>
        <tr>
          <td>Developerアカウント</td>
          <td>shun.dotani+line01@scogr.co.jp<input type="button" value="コピー" class="btn btn-other-action" @click="copy('shun.dotani+line01@scogr.co.jp')" /></td>
        </tr>
        <tr>
          <td>LINE公式ID</td>
          <td>{{ lineOfficialId }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(lineOfficialId)" /></td>
        </tr>
        <tr>
          <td>LINE公式アカウント名</td>
          <td>{{ fixedName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(fixedName)" /></td>
        </tr>
        <tr>
          <td>プロバイダーID</td>
          <td>{{ providerId }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(providerId)" /></td>
        </tr>
        <tr>
          <td>MessagingAPI チャネルID</td>
          <td>{{ messagingChannelId }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(messagingChannelId)" /></td>
        </tr>
        <tr>
          <td>MessagingAPI ボットベーシックID</td>
          <td>{{ messagingBasicId }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(messagingBasicId)" /></td>
        </tr>
        <tr>
          <td>LINEログイン チャネルID</td>
          <td>{{ liffChannelId }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(liffChannelId)" /></td>
        </tr>
        <tr>
          <td>LINEログイン LIFF ID</td>
          <td>{{ liffId }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(liffId)" /></td>
        </tr>
        <tr>
          <td>開始日</td>
          <td>
            基本的には今日。<br>
            未来日にはまだ対応していないので、<br>
            未来日とする場合はその日が来たら手動で契約の同期を実行すること。
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="currentStep === 13">
      <h2>14. サクセス担当者に作業完了を報告</h2>
      <p>毎時0分に実行されるバッチで、paylight上でLINE機能の操作が可能になる。<br>対応完了の旨と、何時から操作が可能になるかをサクセスに連携する。</p>
      <p>Notionに以下のコメントをつけた上で、「対応完了」ボタンを押下する。<br>「対応完了」により、依頼者にNotion上で通知がいくので、基本的にSlack等での連絡も不要。</p>
      <textarea readonly :value="finishReportTxt" class="form-control" rows="12"></textarea>
      <input type="button" value="コピー" class="btn btn-other-action" @click="copy(finishReportTxt)" />
    </div>

    <button class="btn btn-other-action" @click="beforeStep">前工程</button>
    <button v-if="currentStep < 13" class="btn btn-other-action" @click="nextStep">次工程</button>
  </div>
</template>

<style scoped>
</style>

<script>
export default {
  data() {
    return {
      currentStep: 0,
      operationType: 'PLCX',
      dummyEndPointUrl: 'https://chat.clinic.pay-light.com?id_alias=',
      ssRecord: '',
      name: '',
      notionInput: '',
      sfOpportunityId: '',
      shopId: '',
      fixedName: '',
      mail: '',
      providerId: '',
      messagingBasicId: '',
      messagingChannelId: '',
      messagingChannelSecret: '',
      liffId: '',
      liffChannelId: '',
      liffChannelSecret: '',
      lineOfficialId: '',
      follow: '',
      aiCallContractId: null,
      aiCallPlanStartDate: null,
      aiCallPlanEndDate: null,
      plxContractId: null,
      plxContractStartDate: null,
      plxContractEndDate: null
    }
  },
  computed: {
    validNext() {
      return this.shopId !== ''
    },
    messagingApiAlreadyInUseTxt() {
      return [
        'MessagingAPIがすでに利用中の状態でした。',
        'shun.dotani+line01@scogr.co.jp',
        '上記アドレスに、',
        '・プロバイダー',
        '・MessagingAPI',
        '・（作成済みであれば）LINEログイン',
        'の招待をいただけるよう、ご対応をお願いいたします。',
      ].join('\n')
    },
    oamMailNotSetTxt() {
      return [
        'LINE OAM（公式アカウント）の設定＞登録情報＞管理者情報にメールアドレスが設定されいていないので、',
        '設定いただくよう医院さまへご依頼をお願いします。',
      ].join('\n')
    },
    oamRetryTxt() {
      return [
        `LINE OAMの権限が「運用担当者」になっていました。`,
        `「管理者」に変えていただきますよう、医院さまにご連絡をお願いいたします。`
      ].join('\n')
    },
    plxSettingListUrl() {
      return `/manage/store_platform_settings?shop_id=${this.shopId}`
    },
    opsInsightStartTxt() {
      const today = new Date().toISOString().split('T')[0].replace(/-/g, '/')
      const status = 'システム部依頼中'
      return [
        `${this.operationType}`,
        '=ROW()-3',
        `${this.shopId}`,
        `${this.name}`,
        `${this.liffId}`,
        `${this.liffChannelId}`,
        `${this.liffChannelSecret}`,
        `${this.messagingBasicId}`,
        `${this.messagingChannelId}`,
        `${this.messagingChannelSecret}`,
        `${today}`,
        `${status}`
      ].join('\t')
    },
    webhookUrl() {
      const ssArray = this.ssRecord.split('\t')
      return ssArray[15] // P列: Webhook URL
    },
    endPointUrl() {
      const ssArray = this.ssRecord.split('\t')
      return ssArray[14] // O列: エンドポイントURL
    },
    storeListUrl() {
      return `/manage/store_examinations?shop_id=${this.shopId}`
    },
    finishReportTxt() {
      return [
        `LINE接続設定が完了しました。`,
        ``,
        `1)`,
        `paylight X>設定>チャットより、`,
        `「チャットを利用する」をONするとLINEでのやり取りができるようになります。`,
        `本日⚪︎時以降より動作確認が可能な状態になります。`,
        `上記時刻以降に動作確認等お願いいたします。`,
        ``,
        `2)`,
        `SMSやLINEで生成したメッセージの送信開始までにNGTとの調整を完了してください。`,
      ].join('\n')
    },
    plxContractStatus() {
      if (!this.plxContractId) return 'none'
      const today = new Date().toISOString().split('T')[0]
      if (this.plxContractEndDate && this.plxContractEndDate < today) {
        return 'ended'
      }
      return 'active'
    },
    callActiveNoPlxTxt() {
      return [
        'paylight Callが稼働中であり、paylight Xの契約が存在しません。',
        'LINE連携の前にX契約への乗せ替え対応が必要なので、別途乗せ替え依頼をお願いいたします。',
        '',
        'なお、乗せ替え依頼の際は、以下情報もご共有ください。',
        '・Call契約の解約日',
        '・X契約開始日',
        '・（あれば）キャンペーン適用の有無など、乗せ替えに際する申し送り事項',
        '',
        '（LINEオプション使用中の場合）',
        '生成メッセージの開始日とその内容については、別途NGTと調整してください。',
      ].join('\n')
    },
    noPlxContractTxt() {
      return [
        'paylight Xの契約が存在しません。',
        'LINE連携の前にX契約締結が必要なので、別途X契約の新規開設依頼をお願いいたします。',
      ].join('\n')
    },
    callActiveLineLinkedTxt() {
      return [
        'paylight Callの契約が稼働中であり、LINEも連携済みの状態です。',
        '・これまで通り、医院さまで返信される',
        '・AIでの自動返信を行うようにする',
        'どちらにしますか？',
      ].join('\n')
    },
    plxEndedTxt() {
      return [
        'paylight X 契約が解約済みとなっています。',
        '再契約する医院さまでしょうか？',
        '再契約の場合は、改めてXの契約締結が必要になりますので、別途新規開設依頼をお願いいたします。',
      ].join('\n')
    },
    aiCallPlanStatus() {
      if (!this.aiCallContractId) return 'none'
      const today = new Date().toISOString().split('T')[0]
      if (this.aiCallPlanStartDate <= today && (!this.aiCallPlanEndDate || this.aiCallPlanEndDate >= today)) {
        return 'active'
      }
      return 'ended'
    },
  },
  methods: {
    beforeStep() {
      if (this.currentStep > 0) {
        this.currentStep--
      }
    },
    nextStep() {
      if (this.currentStep < 13 && this.validNext) {
        this.currentStep++
      }
    },
    loadShopId() {
      if (!this.notionInput) {
        alert('Notionコピー項目を入力してください。')
        return
      }

      const columns = this.notionInput.split('\t')
      if (columns.length < 4) {
        alert('入力形式が正しくありません。Notionからタブ区切りでコピーしてください。')
        return
      }

      this.name = columns[1].trim()
      this.shopId = columns[2].trim()
      this.follow = columns[3].trim()
      this.fetchStoreData()
    },
    loadSfOpportunity() {
      if (!this.sfOpportunityId) {
        alert('商談IDを入力してください。')
        return
      }

      this.loadSfInsightOpportunity()
    },
    loadSfInsightOpportunity() {
      const unixtime = Math.floor(Date.now() / 1000)
      fetch(`/api/v1/sfo_insight/?id=${this.sfOpportunityId}&tv=${unixtime}`)
          .then(response => {
            if (!response.ok) throw new Error('データ取得に失敗しました')
            return response.json()
          })
          .then(data => {
            this.shopId = data.shopId || ''
            this.name = data.name || ''
            this.follow = data.follow
            this.fetchStoreData()
          })
          .catch(error => {
            alert(error.message)
          })
    },
    fetchStoreData() {
      if (!this.shopId) return
      fetch(`/api/v1/store_data/?shop_id=${this.shopId}`)
        .then(response => {
          if (!response.ok) {
            return response.json().then(body => {
              throw new Error(body.error || 'データ取得に失敗しました')
            })
          }
          return response.json()
        })
        .then(data => {
          this.aiCallContractId = data.aiCallContractId || null
          this.aiCallPlanStartDate = data.aiCallPlanStartDate || null
          this.aiCallPlanEndDate = data.aiCallPlanEndDate || null
          this.plxContractId = data.plxContractId || null
          this.plxContractStartDate = data.plxContractStartDate || null
          this.plxContractEndDate = data.plxContractEndDate || null
        })
        .catch(error => {
          alert(error.message)
        })
    },
    copy(text) {
      navigator.clipboard.writeText(text)
    }
  }
}
</script>